import { SHOPIFY_ASSET_ROOT } from "../constants";

export const cross = `${SHOPIFY_ASSET_ROOT}/cross.svg`;
